import React from 'react';
import { styled, Box, SxProps } from '@mui/material';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Icon } from '@iconify/react';

const DatePickerCtn = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,

  backgroundColor: theme.palette.grey[200],
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1.2),

  '&:hover': {
    cursor: 'pointer',
  },

  ' .react-datepicker-wrapper': {
    outline: 'none',
    border: 'none',
  },

  input: {
    flex: 1,
    outline: 'none',
    border: 'none',
    backgroundColor: theme.palette.grey[200],
    '&:hover': {
      cursor: 'pointer',
    },
  },

  ' .react-datepicker': {
    border: 'none !important',
    minWidth: '350px',
    padding: 1,
    boxShadow: theme.shadows[5],
  },

  ' .react-datepicker__header': {
    backgroundColor: theme.palette.common.white,
    border: 'none',
  },

  ' .react-datepicker__month-container': {
    width: '100%',
    border: 'none',
  },

  ' .react-datepicker__week': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  ' .react-datepicker__day-name': {
    color: theme.palette.grey[600],
  },

  ' .react-datepicker__day-names': {
    margin: 0,
    border: 'none',
    display: 'flex',
    justifyContent: 'space-between',
  },

  ' .react-datepicker__day': {
    color: theme.palette.grey[700],
  },

  ' .react-datepicker__day--today': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: 10,
  },

  ' .react-datepicker__day--selected, .react-datepicker__day--keyboard-selected, .react-datepicker__day--in-range': {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
    borderRadius: 10,
  },
}));

interface Props extends ReactDatePickerProps<string | never, undefined | boolean> {
  hideIcon?: boolean;
  sx?: SxProps;
}

const DatePicker: React.FC<Props> = ({ hideIcon, sx, ...rest }) => {
  return (
    <DatePickerCtn sx={sx}>
      {!hideIcon && <Icon icon="akar-icons:calendar" fontSize={24} />}
      <ReactDatePicker showPopperArrow={false} {...rest} />
    </DatePickerCtn>
  );
};

export default DatePicker;
